const NAMESPACE = 'real-device-selection' as const;

const LS_MOBILE_SELECTION_CURRENT_VIEW = 'mobileSelectionCurrentView' as const;

const DEVICE_SORT_MODES = Object.freeze({
  A_TO_Z: 'A_TO_Z',
  PINNED_FIRST: 'PINNED_FIRST',
  PREFERRED_FIRST: 'PREFERRED_FIRST',
  Z_TO_A: 'Z_TO_A',
} as const);

const MOBILE_SELECTION_FILTER = Object.freeze({
  ANDROID: 'ANDROID',
  CARRIER: 'CARRIER',
  COMPATIBILITY: 'COMPATIBILITY',
  IOS: 'IOS',
  PRIVATE: 'PRIVATE',
  PHONE: 'PHONE',
  TABLET: 'TABLET',
} as const);

const MOBILE_SELECTION_FILTER_CATEGORY = Object.freeze({
  CLOUD_TYPE: 'cloudType',
  COMPATIBILITY: 'compatibility',
  DATA_CENTER_ID: 'dataCenterId',
  FORM_FACTOR: 'formFactor',
  MANUFACTURER: 'manufacturer',
  NETWORK_TYPE: 'networkType',
  OS: 'os',
  OS_VERSION: 'osVersion',
  RESOLUTION: 'resolution',
  SEARCH: 'search',
} as const);

const MOBILE_SELECTION_FACETS = Object.freeze({
  MANUFACTURER: 'manufacturer',
  OS: 'os',
  OS_VERSION: 'osVersion',
  RESOLUTION: 'resolution',
  SCREEN_SIZE: 'screenSize',
} as const);

const DEVICE_SUBSCRIPTION_VARS = Object.freeze({
  FREE: 'FREE',
  PAID: 'PAID',
} as const);

const DEVICE_CLOUDTYPE = Object.freeze({
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
} as const);

const DEVICE_FORM_FACTOR = Object.freeze({
  PHONE: 'PHONE',
  TABLET: 'TABLET',
} as const);

const SORT_CATEGORIES = Object.freeze({
  FREE: 'free',
  PINNED: 'pinned',
  PRIVATE: 'private',
  PHONES: 'phones',
  OTHER: 'other',
} as const);

const BRANDS = Object.freeze({
  APPLE: 'apple',
  SAMSUNG: 'samsung',
  GOOGLE: 'google',
  OTHER: 'other',
  IOS_17_PAID: 'ios_17_paid',
  IOS_17_FREE: 'ios_17_free',
});

// migrated from sl-component-device-grid
// TODO: check if needed
const BROWSER_TYPES = Object.freeze({
  NONE: 'NONE',
  CHROME: 'CHROME',
  EDGE: 'EDGE',
  FIREFOX: 'FIREFOX',
  IE: 'IE',
  SAFARI: 'SAFARI',
} as const);
const OS_TYPES = Object.freeze({
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  LINUX: 'LINUX',
  MAC_OS: 'MAC_OS',
  OSX: 'OSX',
  WINDOWS: 'WINDOWS',
} as const);
const TOOLTIP_LABELS = Object.freeze({
  BUSY_DEVICE: 'Temporarily unavailable',
  LOCKED_DEVICE: 'Upgrade your account to use this device',
  PINNED_BUTTON_ACTIVE: 'Unpin',
  PINNED_BUTTON_INACTIVE: 'Pin to top',
  PRIVATE_DEVICE: 'Private',
} as const);

// migrated from sl-module-devices-rdc
// TODO: check if needed
const MOBILE_DATA_CENTER_NAMES = {
  EU: 'Europe',
  US: 'United States',
} as const;
const DEFAULT_MOBILE_BROWSERS = {
  ANDROID: 'CHROME',
  IOS: 'SAFARI',
} as const;
const MIN_WEBRTC_OS_VERSION = {
  ANDROID: '10.0.0',
  IOS: '13.2.0',
} as const;
const CPU_CORE_NAMES = {
  1: 'single',
  2: 'dual',
  3: 'triple',
  4: 'quad',
  6: 'hexa',
  8: 'octa',
} as const;
const MOBILE_DEVICE_FEATURES = {
  BIOMETRICS_AUTHENTICATION: 'BIOMETRICS_AUTHENTICATION',
  CHANGE_LOCALE: 'CHANGE_LOCALE',
  DEV_TOOLS: 'DEV_TOOLS',
  EXECUTE_SHELL_COMMAND: 'EXECUTE_SHELL_COMMAND',
  PRESS_BACK: 'PRESS_BACK',
  PRESS_HOME: 'PRESS_HOME',
  PRESS_MENU: 'PRESS_MENU',
  PRESS_SEARCH: 'PRESS_SEARCH',
  TOGGLE_SYSTEM_ANIMATIONS: 'TOGGLE_SYSTEM_ANIMATIONS',
  TOGGLE_WIFI: 'TOGGLE_WIFI',
} as const;
const MOBILE_PLATFORMS = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
} as const;

const DEVICE_STATE = {
  AVAILABLE: 'AVAILABLE',
  CLEANING: 'CLEANING',
  IN_USE: 'IN_USE',
  MAINTENANCE: 'MAINTENANCE',
  OFFLINE: 'OFFLINE',
  REBOOTING: 'REBOOTING',
};

const DEVICE_PREFIX_REGEX = /^.*(?=_\d*$)/;

// ^(.*?)(?:_\d+)?$
export default {
  BRANDS,
  BROWSER_TYPES,
  CPU_CORE_NAMES,
  DEFAULT_MOBILE_BROWSERS,
  DEVICE_CLOUDTYPE,
  DEVICE_FORM_FACTOR,
  DEVICE_PREFIX_REGEX,
  DEVICE_SORT_MODES,
  DEVICE_STATE,
  DEVICE_SUBSCRIPTION_VARS,
  LS_MOBILE_SELECTION_CURRENT_VIEW,
  MIN_WEBRTC_OS_VERSION,
  MOBILE_DATA_CENTER_NAMES,
  MOBILE_DEVICE_FEATURES,
  MOBILE_PLATFORMS,
  MOBILE_SELECTION_FILTER,
  MOBILE_SELECTION_FILTER_CATEGORY,
  MOBILE_SELECTION_FACETS,
  NAMESPACE,
  OS_TYPES,
  SORT_CATEGORIES,
  TOOLTIP_LABELS,
};
